<template>
  <div class="container">
    <div class="row">
      <div class="col d-flex justify-content-center align-items-center">
        <div class="text-center">
          <div class="">
            <img src="404.jpg" class="img-responsive" />
          </div>
          <div class="mt-5">
            <h1 class="display-4">
              The Page You Are Looking For Is Not Found !
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style></style>
